import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import { withTranslation } from 'react-i18next';
import OfferCardGridItemComponent from '../OfferCardGridItemComponent';
import Button from '../Shared/components/controls/Button/index.js';
import './style.scss';

const RelatedOffersComponent = ({ routeData = {}, fields = {}, t, i18n, params }) => {
  const { displayLink, heading, link, text } = fields;
  const { relatedOffers } = routeData;

  const shouldRenderDisplayLink = !!displayLink?.value && displayLink.value;
  const shouldRenderHeading = !!heading?.value;
  const shouldRenderLink = !!link?.value?.href;
  const shouldRenderText = !!text?.value;
  const shouldRenderRelatedOffers = Array.isArray(relatedOffers) && relatedOffers.length > 0;

  return (
    <div className={clsx('related__offers content', 'add-margins', params?.Styles)}>
      <div className="related__offers--header">
        <div className="related__offers--header_desc">
          {shouldRenderHeading && (
            <h3>
              <Text field={heading} />
            </h3>
          )}
          {shouldRenderText && <RichText className="related__offers-desc" field={text} />}
        </div>
        {shouldRenderDisplayLink && shouldRenderLink && (
          <Button className="related__offers-cta" link={link} arrow="right" />
        )}
      </div>
      {shouldRenderRelatedOffers && (
        <div className="related__offers--offers flex-it flex-wrap">
          {relatedOffers.map((item, index) => {
            const newItem = {
              ...item,
              fields: {
                ...item?.fields,
                tags: item?.fields?.offerTags,
              },
            };
            return (
              <OfferCardGridItemComponent
                key={index}
                item={newItem}
                lang={i18n.language}
                translate={t}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default withTranslation()(RelatedOffersComponent);
